export default "__VITE_ASSET__D7r_baOx__"